// @flow

import styled, { css } from 'styled-components';
import { media } from '@leasen_nl/listo/src/helpers';
import type { Theme } from '@types/index';

export const ActionsWrapper = styled<any, Theme>('div')`
  padding: 1rem 0.5rem 0;
  text-align: left;

  > a {
    width: 100%;
    ${media.sm(css`
      width: calc(50% - 0.5rem);

      &:first-of-type {
        margin-right: 1rem;
      }
    `)}
    ${media.md(css`
      width: auto;
    `)};
  }
`;

export default null;
